import * as yup from "yup";

const companySchema = yup.object().shape({
  CompanyName: yup
    .string()
    .required("Company Name is required")
    .max(100, "Company Name must be at most 100 characters"),
  Address1: yup
    .string()
    .required("Address 1 is required")
    .max(100, "Address 1 must be at most 100 characters"),
  Address2: yup
    .string()
    .nullable()
    .max(100, "Address 2 must be at most 100 characters"),
  City: yup
    .string()
    .required("City is required")
    .max(50, "City must be at most 50 characters"),
  StateProvinceCode: yup
    .string()
    .required("Province is required")
    .max(2, "Province must be at most 2 characters"),
  ZipPostalCode: yup
    .string()
    .required("Postal Code is required")
    .max(10, "Postal Code must be at most 10 characters"),

  // Contract
  ContractSignedDate: yup.string().nullable(),
  ContractDocuSignLink: yup
    .string()
    .nullable()
    .max(500, "DocuSign Link must be at most 500 characters"),
  ContractDocuSignEnvelopeId: yup
    .string()
    .nullable()
    .max(100, "DocuSign Envelope ID must be at most 100 characters"),

  // Signatory
  SignatoryName: yup
    .string()
    .nullable()
    .max(100, "Signatory Name must be at most 100 characters"),
  SignatoryTitle: yup
    .string()
    .nullable()
    .max(100, "Signatory Title must be at most 100 characters"),
  SignatoryEmail: yup
    .string()
    .nullable()
    .email("Signatory Email must be a valid email")
    .max(100, "Signatory Email must be at most 100 characters"),
  SignatoryPhone: yup
    .string()
    .nullable()
    .max(25, "Signatory Phone must be at most 25 characters"),

  // MK154A
  MK154AIsSubmitted: yup.boolean(),
  MK154AConfirmedDate: yup.string().nullable(),
  MK154ANotes: yup
    .string()
    .nullable()
    .max(500, "MK154A Notes must be at most 500 characters"),
});

export default companySchema;